
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CLAccount } from './account';
import { CLAccountService, CLAccountFilter } from './account.service';
import { CLAccountFilterDialogComponent } from './account-filter-dialog.component';
import { NotifierService, DialogService } from '../../ui';

const FILTER_KEY = 'client-accounts-deleted.filter';

@Component({
  templateUrl: './account-deleted.component.html',
})
export class CLAccountDeletedComponent implements OnInit {

  filter: CLAccountFilter;

  perPage = 10
  accountsCount: number = 0
  accounts: CLAccount[]

  constructor(
    private accountService: CLAccountService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new CLAccountFilter();
    this.filter.deleted = true;

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.accounts.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.accountService
      .accounts(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.accounts = result.accounts;
        }
        // Append
        else {
          this.accounts = [...this.accounts || [], ...result.accounts];
        }

        this.accountsCount = result.accountsCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showCLAccount(account: CLAccount, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['shares-ledger', 'client-accounts', 'deleted', account.id]);
    }
  }

  applyFilter() {
    this.dialogService.show({
      component: CLAccountFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: CLAccountFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }

  restore(account: CLAccount) {
    this.dialogService
      .confirm({
        title: 'Restauration',
        message: 'Voulez-vous restaurer ce compte client?',
        confirm_button_text: 'Restaurer',
        confirm_button_class: 'btn-primary'
      })
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.accountService
          .restore(account.id)
          .subscribe((id) => {
            this.notifier.success('Compte client restauré avec succès');

            this.fetch(0, this.accounts.length, true);
          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }
}
